// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"03d5502e","703":"c66ff042","787":"0af5f2e9"}[chunkId] + ".chunk.js";
};